export const FORM_EVENT = {
  LOADING: 'loading',
  LOADED: 'loaded',
  SAVED: 'saved',
  SUBMITTED: 'submitted',
  ERROR: 'error'
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/constant/form-event.constant.ts